module.exports = __webpack_public_path__ + "static/media/crm_temp_open_rate.d2d29913.svg";